{
  "dataTable": {
    "view": "View",
    "columns": "Columns",
    "rowsSelected_one": "{{count}} of {{total}} row selected",
    "rowsSelected_other": "{{count}} of {{total}} rows selected",
    "totalResults_one": "{{count}} result",
    "totalResults_other": "{{count}} results",
    "filteredResults_one": "{{filtered}} of {{total}} result",
    "filteredResults_other": "{{filtered}} of {{total}} results",
    "rowsPerPage": "Rows per page",
    "page": "Page {{current}} of {{total}}",
    "noResults": "No results.",
    "noResultsFound": "No results found.",
    "pagination": {
      "goToFirstPage": "Go to first page",
      "goToPreviousPage": "Go to previous page",
      "goToNextPage": "Go to next page",
      "goToLastPage": "Go to last page"
    },
    "search": "Search...",
    "filterValuePlaceholder": "Enter {{label}}...",
    "selectPlaceholder": "Select...",
    "sortAscending": "Sort ascending",
    "sortDescending": "Sort descending",
    "sortThenAscending": "Then ascending",
    "sortThenDescending": "Then descending",
    "sortRank": "Sort order {{rank}}",
    "clearSort": "Clear sort",
    "addFilter": "Add filter",
    "clearFilter": "Clear filter",
    "hideColumn": "Hide column",
    "filtered": "Filtered",
    "groupBy": "Group by {{label}}",
    "filters": {
      "searchPlaceholder": "Search...",
      "selectPlaceholder": "Select...",
      "all": "All",
      "from": "From",
      "to": "To",
      "min": "Min",
      "max": "Max",
      "activeFilters": "Active Filters",
      "clearAll": "Clear All",
      "removeFilter": "Remove filter"
    },
    "resetColumns": "Reset to default"
  }
}
